module.exports = __webpack_public_path__ + "static/media/05_galeria_plantillas_combo_duo_rec_2.cf82c237.png";